






































import { get } from 'lodash';
import ZenMultiselect from '@reciprocity/multiselect';
import { parseISO } from 'date-fns';
import { BAlert } from 'bootstrap-vue';
import { buildQuickSuggestions } from './suggestions';
import { PeriodOptions } from './utils';
import RepeatEnd from './RepeatEnd.vue';
import CustomRepeat from './CustomRepeat.vue';

export default {
  name: 'Repeat',
  components: {
    ZenMultiselect,
    RepeatEnd,
    CustomRepeat,
    BAlert,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showAlert: false,
    };
  },
  computed: {
    repeatOptions() {
      return buildQuickSuggestions(this.form.endDate);
    },
    showCustomRepeat() {
      return this.form.endDate && this.form.repeatOption && this.form.repeatOption.value === PeriodOptions.Custom;
    },
    showRepeatEnd() {
      return (
        this.form.endDate && this.form.repeatOption && this.form.repeatOption.value !== PeriodOptions.DoesNotRepeat
      );
    },
    repeatOnMessage() {
      if (this.form.repeatOption && this.form.repeatOption.value === PeriodOptions.DoesNotRepeat) {
        return '';
      }

      const endDate = parseISO(this.form.endDate);
      const endDateDate = endDate.getDate();
      if (
        (this.form.repeatOption && this.form.repeatOption.label.includes(endDateDate)) ||
        (this.showCustomRepeat && this.form.repeatOn && this.form.repeatOn.label.includes(endDateDate))
      ) {
        if (endDate.getMonth() === 1 && endDateDate === 29) {
          // leap years
          return '29th of February will be treated as 28th of February on non-leap years.';
        }

        if (endDateDate > 28) {
          return `This ${this.objectType} will not occur in months with <strong>fewer days</strong> than selected. Instead, select <strong>Last day of the month</strong> option.`;
        }
      }

      return '';
    },
  },
  watch: {
    'form.endDate'() {
      this.restoreValues();
    },
    'form.repeatOption'() {
      this.showWarning(this.repeatOnMessage);
    },
    'form.repeatOn'() {
      this.showWarning(this.repeatOnMessage);
    },
    repeatOnMessage(message) {
      this.showWarning(message);
    },
  },
  created() {
    if (!this.form.repeatOption) {
      this.form.repeatOption = this.repeatOptions[0];
    }
  },
  methods: {
    restoreValues() {
      if (!this.showCustomRepeat) {
        let existingElement;
        const repeatOption = get(this.form, 'repeatOption.value');
        if (repeatOption) {
          existingElement = this.repeatOptions.find(opt => opt.value === repeatOption);
        }

        if (existingElement) {
          this.form.repeatOption = existingElement;
        } else {
          this.form.repeatOption = this.repeatOptions[0];
        }
        this.form.repeatOn = null;
      }

      if (!this.form.endDate) {
        this.form.repeatOn = null;
        this.form.repeatOption = this.repeatOptions[0];
      }
    },
    showWarning(message) {
      if (message) {
        this.updateAlertVisibility(true);
      }
    },
    updateAlertVisibility(show) {
      this.showAlert = show;
    },
  },
};
